import React from 'react'
import classNames from 'classnames'

const Input = props => {
  const { field, errors, register } = props
  const { id, label, description, autocomplete, cssClass } = field
  const hasErrors = errors[id]

  return (
    <div
      className={classNames('fieldContainer', cssClass, { error: hasErrors })}
      key={`field-${id}`}
    >
      <input
        {...register(id)}
        className={errors[id] ? 'error' : ''}
        placeholder={label}
        autoComplete={autocomplete}
      />

      {hasErrors && (
        <div className="error-message">
          <img src="/themes/thrifty/assets/images/form-error.svg" />
          {errors[id]?.message}
        </div>
      )}

      {description && <p className="fieldDescription">{description}</p>}
    </div>
  )
}
export default Input
